import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import * as React from "react";
import "./Regeneratepopup.css";

const RegenerateButton = styled(Button)(({ theme }) => ({
 color: "black",
 textTransform: "none",
 border: "solid 1px #6019F9",
 borderRadius: "20px",
 backgroundColor: "white",
 "&:hover": {
  backgroundColor: "white",
 },
}));

export default function Regeneratepopup(props) {
 const handleClose = () => {
  props.setOpen(false);
 };
 const [userQuery, setUserQuery] = React.useState(null);
 return (
  <React.Fragment>
   <Dialog open={props.open} onClose={handleClose} className="regenerate-pop">
    <DialogTitle>Do you want to enter any prompt for regeneration?</DialogTitle>
    <DialogContent>
     <TextField
      label="Enter the description"
      id="multiline"
      multiline
      minRows={4}
      maxRows={8}
      sx={{ width: "100%" }}
      onChange={(e) => setUserQuery(e.target.value)}
     />

     <Accordion sx={{ mt: 2 }}>
      <AccordionSummary
       expandIcon={<ExpandMoreIcon />}
       aria-controls="panel1-content"
       id="panel1-header"
      >
       <Typography variant="h6" sx={{ fontSize: "14px" }}>
        Additional Notes By Requestor
       </Typography>
      </AccordionSummary>
      <AccordionDetails>
       <Typography variant="h6" sx={{ fontSize: "14px" }}>
        {props.requestorData}
       </Typography>
      </AccordionDetails>
     </Accordion>
    </DialogContent>
    <DialogActions>
     <RegenerateButton
      onClick={() => {
       props.handleRegeneration(userQuery);
       handleClose();
      }}
     >
      Regenerate
     </RegenerateButton>
     <RegenerateButton
      onClick={() => {
       handleClose();
      }}
     >
      Cancel
     </RegenerateButton>
    </DialogActions>
   </Dialog>
  </React.Fragment>
 );
}
